import { Modal, Form, message } from 'antd';
import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useApi } from '../../hooks/use_api';
import CreateEntityForm, { windowFields } from './CreateEntityForm';

function CreateEntityModal({ open, onCancel, onSuccess, defaultEntityType = 'context', showListedToggle = false }) {
    const [form] = Form.useForm();
    const [creating, setCreating] = useState(false);
    const { userPersonEntity } = useAuth();
    const api = useApi();

    const handleCreate = async (values) => {
        setCreating(true);
        try {
            const rawAttrs = values.attributes ? JSON.parse(values.attributes) : {};
            const personFieldValues = {};
            for (const [k, v] of Object.entries(values.person_fields || {})) {
                if (v === undefined || v === null || v === '') continue;
                personFieldValues[k] = v?.toISOString ? v.toISOString() : v;
            }

            const payload = {
                name: values.name,
                entity_type: values.entity_type,
                url: values.url || null,
                email: values.email || null,
                attributes: { ...rawAttrs, ...personFieldValues },
                description: values.description?.trim() || null,
                is_listed: showListedToggle ? !!values.is_listed : false,
                ...windowFields(values.when),
                ...(userPersonEntity?.id ? { created_by: userPersonEntity.id } : {}),
            };

            await api.post('/api/entities', payload);

            message.success('Entity created!');
            form.resetFields();
            onSuccess?.();
            onCancel?.();
        } catch (error) {
            message.error(error.message || 'Failed to create entity');
            console.error(error);
        } finally {
            setCreating(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel?.();
    };

    return (
        <Modal title="Create New Entity" open={open} onCancel={handleCancel} footer={null} width={560}>
            <CreateEntityForm
                form={form}
                onFinish={handleCreate}
                loading={creating}
                onCancel={handleCancel}
                defaultEntityType={defaultEntityType}
                showListedToggle={showListedToggle}
            />
        </Modal>
    );
}

export default CreateEntityModal;
